import { forwardRef, type Ref, type SVGProps } from "react";

function SvgRefresh(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.638 12.5a6.875 6.875 0 1 0 6.484-9.167c-2.348 0-3.917 1.004-5.434 2.716m-.625-2.507V6.25c0 .345.28.625.625.625h2.708"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRefresh);
export default ForwardRef;
